import React, {useContext} from 'react';
import {defineMessages} from 'react-intl';
import {Button} from '@igp/shared/components/button';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ModalContext} from '@igp/shared/components/modal';

import {useReferralLinkConfigActionStatuses} from '../hooks';

import {EditReferralLinkConfigModal} from './EditReferralLinkConfigModal';

const localized = defineMessages({
    addMapping: {
        id: 'ReferralLinkConfig_addMapping',
        defaultMessage: 'Add Mapping',
    },
});

export function AddReferralLinkConfigButton() {
    const {openModal, closeModal} = useContext(ModalContext);
    const {isAddInProgress} = useReferralLinkConfigActionStatuses();

    function handleAddMapping() {
        openModal({
            title: <LocalizedText label={localized.addMapping} />,
            body: <EditReferralLinkConfigModal initialModel={null} onSave={closeModal} onCancel={closeModal} />,
        });
    }

    return (
        <Button color="primary" variant="contained" label={localized.addMapping} onClick={handleAddMapping} disabled={isAddInProgress} />
    );
}
